<div [formGroup]="form">
    <mat-label class="font-style" [ngbTooltip]="m_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
        {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.PADDITIONAL' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #m_tooltip>
        <p>
            {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.PADDITIONAL' | transloco }}
        </p>
    </ng-template>

    <div class="example-checkbox" [ngClass]="form.get('pAdditional').valid ? '' : 'highLight'">
        <div>
            <mat-checkbox class="example-margin checkbox-wrap" name="resultOptionEl" formControlName="ispAdditional"></mat-checkbox>
        </div>
        <mat-form-field class="example-full-width" [floatLabel]="'never'">
            <input
                matInput
                formControlName="pAdditional"
                name="pAdditional"
                type="number"
                #tooltip="matTooltip"
                matTooltip="Enter only digits"
                [matTooltipDisabled]="form.get('pAdditional').valid"
                placeholder=""
                [readonly]="!form.get('ispAdditional').value"
            />
        </mat-form-field>
    </div>
</div>
